const partialDisplayField = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDisplayFields.hbs');

define(function (require) {
	var getMap = function (ele, detailOptions) {
		var mapletId = ele.mapletId;
		var delegateFormula = '';
		if (mapletId.indexOf('?') > -1) {
			delegateFormula = mapletId.substring(mapletId.indexOf('?') + 1);
			mapletId = mapletId.substring(0, mapletId.indexOf('?'));
		}

		var requiredClass = (ele.isRequired) ? ' required' : '';
		var el = $('<div/>', {});
		var mapRow = $('<div/>', { class: 'wizard-map-wrap map-wrapper' });
		var map = $('<div/>', {
			class: 'wizard-map mapView applet-region' + requiredClass,
			id: ele.id,
			'data-maplet': mapletId,
			'data-maplet-delegate': delegateFormula,
			value: ele.value,
			style: ''
		});
		var requiredAddOn = (ele.isRequired) ? '<em class="required">*</em>' : '';

		var mapResult = $('<div/>', { class: 'results-region wizard-map-wrap-item map-result field' });
		mapResult.html(' ');
		mapRow.append(map);
		mapRow.append(mapResult);

		var el = $('<div/>', {});

		var mapTitle = $('<h3/>', {
			class: 'map-title'
		});
		mapTitle.text(i18n.t('CIVICS.INSTRUMENT_SUBMIT.MAP_TITLE'));
		mapTitle.append(requiredAddOn);

		var mapSearchHelper = $('<em/>', {
			class: 'map-search-helper'
		});
		mapSearchHelper.text(i18n.t('CIVICS.INSTRUMENT_LIST.SEARCH_HELPER_TEXT'));

		// Added a error message helper here to handle scenario when mapresult is still hidden.
		var mapErrorMessageHelper = $('<div/>', { class: 'field map-error-message-helper' });
		if (ele.isRequired) {
			mapErrorMessageHelper.append($(partialDisplayField($.extend({}, { 'helperMsgId': ele.id + "-helper", 'helperMsg': ' ' }))));
		}

		el.append(mapTitle);
		if (ele.text || ele.description) {
			var displayData = {
				id: ele.id,
				classes: '',
				labelText: ele.text,
				helperMsg: " ",
				helperMsgId: ele.id + "-helper",
				html: false,
				disabled: false,
				showValue: true
			};
			if (ele.description) {
				displayData.tooltip = general_utils.attributeEscapeString(ele.description);
			}
			el.append($(partialDisplayField($.extend({}, displayData))));
		}

		el.append(mapErrorMessageHelper);
		el.append(mapSearchHelper);
		el.append(mapRow);


		return el;
	};
	return {
		getMap: function (ele, detailOptions) {
			return getMap(ele, detailOptions);
		}
	}
});